<div class="d-flex lang-switcher-component">
    <label for="currentLanguage" class="visually-hidden">Current Language</label>
    <ng-select class="e-select lang-switcher"
               [ngClass]="langswitcherPosition"
               appendTo="body"
               [items]="languages"
               [closeOnSelect]="true"
               [clearable]="false"
               [searchable]="false"
               labelForId="currentLanguage"
               [(ngModel)]="currentLanguage"
               (change)="setLanguage($event)"
               (open)="addDropdownPanelClass()">
        <ng-template ng-label-tmp let-item="item">
            <div class="d-flex">
                <span class="material-icons lang-switcher-image">public</span>
                <span class="lang-switcher-label" *ngIf="!isMobile">
                    {{ (getLabel(item) | translate)?.toUpperCase() }}
                </span>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <span class="lang-switcher-label" [ngOptionHighlight]="search">
                {{ (('languages.' + item) | translate).toUpperCase() }}
        </span>
        </ng-template>
    </ng-select>
</div>

